// Import React
import React from "react";

// This renders summary insights for the selected plan
export default function PricingInsightsBar({
    selectedPlan,
    lowestBasePrice,
    averageBasePrice,
    maxSavingsVsRegistered,
    showIncludingTax,
    formatMoney,
}) {

    // Render insights bar
    return (
        <section className="pod-pricing-page__insights-bar">

            {/* This is one insight card */}
            <div className="pod-pricing-page__insight-card">
                <span className="pod-pricing-page__insight-label">Viewing Plan</span>
                <strong className="pod-pricing-page__insight-value">{selectedPlan?.name || "N/A"}</strong>
            </div>

            {/* This is one insight card */}
            <div className="pod-pricing-page__insight-card">
                <span className="pod-pricing-page__insight-label">Lowest Base Price</span>
                <strong className="pod-pricing-page__insight-value">{formatMoney(lowestBasePrice)}</strong>
            </div>

            {/* This is one insight card */}
            <div className="pod-pricing-page__insight-card">
                <span className="pod-pricing-page__insight-label">Average Base Price</span>
                <strong className="pod-pricing-page__insight-value">{formatMoney(averageBasePrice)}</strong>
            </div>

            {/* This is one insight card */}
            <div className="pod-pricing-page__insight-card">
                <span className="pod-pricing-page__insight-label">Best Saving vs Registered</span>
                <strong className="pod-pricing-page__insight-value">{formatMoney(maxSavingsVsRegistered)}</strong>
            </div>

        </section>
    );

}